import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import JobIndex from './pages/JobIndex'
import JobShow from './pages/JobShow'
import JobNew from './pages/JobNew'
import JobEdit from './pages/JobEdit'

export const AdminJobRouter = () => {
  return (
    <BrowserRouter>
      <Routes>
      <Route path="/admins" element={<JobIndex />} />
        <Route path="/admins/jobs" element={<JobIndex />} />
        <Route path="/admins/jobs/new" element={<JobNew />} />
        <Route path="/admins/jobs/edit/:id" element={<JobEdit />} />
        <Route path="/admins/jobs/:id" element={<JobShow />} />
      </Routes>
    </BrowserRouter>
  )
}
